var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSplashLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 267.75,
    height: 202.409,
    viewBox: "0 0 267.75 202.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10598",
    "data-name": "Rectangle 10598",
    width: 267.75,
    height: 202.409,
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "splashLogo",
    transform: "translate(0 118.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14562",
    "data-name": "Group 14562",
    transform: "translate(0 -118.134)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M206.3,66.163,142.047,4.2a15.383,15.383,0,0,0-21.12,0L78.466,45.148l45.25,43.664a16.881,16.881,0,0,1,0,24.378,18.02,18.02,0,0,1-11.88,5.02l.324.312a16.759,16.759,0,0,1-.025,24.4,18.357,18.357,0,0,1-23.657,1.369,16.761,16.761,0,0,1-5.205,11.625,18.33,18.33,0,0,1-25.281-.024l-4.184-4.035a16.887,16.887,0,0,1-5.2,11.48,17.785,17.785,0,0,1-10.313,4.9l31.082,29.974a15.417,15.417,0,0,0,21.147,0L206.3,86.554a14.076,14.076,0,0,0,0-20.391M176.667,67.7l-.127.144a4.646,4.646,0,0,1-6.326,0L140.328,39a4.188,4.188,0,0,1,0-6.076l.127-.144a4.6,4.6,0,0,1,6.326,0L176.667,61.6a4.216,4.216,0,0,1,0,6.1",
    transform: "translate(57.075 0.001)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M100.748,143.681,67.973,112.122l5.8-5.6L120,151.127a11.185,11.185,0,0,0,15.416,0,10.288,10.288,0,0,0,0-14.867L89.167,91.683l5.778-5.6,53.944,52.046a11.185,11.185,0,0,0,15.416,0,10.234,10.234,0,0,0,0-14.891l-53.944-52,5.778-5.6L160.47,108.4a11.153,11.153,0,0,0,15.391,0,10.253,10.253,0,0,0,.05-14.819l-.05-.048L130.584,49.869,102.665,22.945l-7.995-7.686C73.825-4.892,39.755-5.06,18.661,14.8l-.224.216-2.466,2.354a51.206,51.206,0,0,0,0,74.311l69.336,66.889a1.236,1.236,0,0,0,.2.168,1.7,1.7,0,0,0,.324.264,11.176,11.176,0,0,0,14.918-.432,10.317,10.317,0,0,0,0-14.891",
    transform: "translate(0.001 0.035)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplashLogo);
export default __webpack_public_path__ + "static/media/splashLogo.8cc40cdcdbe048d9b90030bca4d3f86f.svg";
export { ForwardRef as ReactComponent };